import Scrollbar from 'smooth-scrollbar';

class Table {

	constructor(table) {
		this.table = table
		this.remove = this.table.find('[data-table-remove]');
		this.more = this.table.parent().find('[data-table-more]')
		this.bodyScroll = this.table.find('[data-body-scroll]');
		this.scrollBar = null;
	}

	initialize() {
		const that = this;

		this.remove.on('click', function(e) {
			let el = $(this);
			let cart = el.closest('[data-cart]');
			let product = el.closest('[data-product-id]');
			let products = product.parent();
			let count = cart.find('[data-table-count]');

			product.remove();

			if (products.children().length == 0) {
				products.closest('[data-cart]').children().remove();
				$('[data-cart--null]').removeClass('d-none');
			}

			count.text(products.children().length);
			window.summTotal(cart);

			e.preventDefault();
		});

		this.more.on('click', function() {
			that.table.addClass('show');
			$(this).addClass('d-none');
		});

        if (this.bodyScroll[0]) {
            this.scrollBar = Scrollbar.init(this.bodyScroll[0], {
                damping: 0.5,
                thumbMinSize: 20,
                renderByPixels: true,
                alwaysShowTracks: true
            })
        }
	}
}

export {Table};	

$(window).on('load', function() {
	let tables = [];
	if ($('[data-table]').length > 0) {
		$('[data-table]').each(function(i) {
			tables[i] = new Table($(this));
			tables[i].initialize();
		});
	}
});
